import { CustomTabPanel } from "@/erp/sale";
import {
  a11yProps,
  EstadosOrdenTrabajoEnumChoice,
  sizeTab,
} from "@/shared";
import {
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTabsFormOnly } from "@/shared/hooks";
import { Box, Tab, Tabs } from "@mui/material";
import TableInstalacionesTecnicos from "../../shared/TableInstalacionesTecnicos";
import TableSolicitudATSFisico from "../../shared/TableSolicitudATSFisico";

// export type FormMotivosFiltro = {
//   motivocorreccioncontrato: string;
// };

export default function InstalacionesTecnicosPage() {
  //HOOK PERSONALIZADO

  // const {
  //   data: motivosCorreccionContrato,
  //   isLoading: isLoadingMotivosCorreccionContrato,
  // } = useFetchMotivosRechazo({
  //   estado: true,
  //   modulo: ModulosEnumChoice.CONTRATOS,
  //   page_size: 256,
  //   nombre: "TECNICO",
  // });





  const {valueTab, setValueTab} = useTabsFormOnly({initialTabValue: 0})

  return (
    <>
    
    <SingleTableBoxScene
      title={"Instalaciones Técnicos"}
      visibleReport={true}
    >
      {/* <Grid container spacing={2}> */}
        {/* <Grid item xs={12} sx={{ display: "flex" }}>
          <CustomAutocompleteArrString
            size={gridSizeMdLg6}
            label="Motivo Corrección"
            name="motivocorreccioncontrato"
            control={form.control}
            defaultValue={form.getValues().motivocorreccioncontrato || ""}
            options={
              motivosCorreccionContrato?.data?.data
                ?.map((item) => item.nombre)
                ?.concat([""])!
            }
            isLoadingData={isLoadingMotivosCorreccionContrato}
            error={errors.motivocorreccioncontrato as FieldError}
            helperText={errors.motivocorreccioncontrato?.message as ReactNode}
            disableClearable
          />
          <SingleIconButton
            size={gridSizeMdLg1}
            startIcon={<FilterAltOffIcon />}
            onClick={() => {
              form.setValue("motivocorreccioncontrato", "");
            }}
          />
        </Grid> */}


            <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
              <Tabs
                value={valueTab}
                onChange={(_event: React.SyntheticEvent, newValue: number) => {
                  setValueTab(newValue);
                }}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                aria-label="scrollable force tabs preventa"
              >
                <Tab label={'Rechazadas por Técnico'} {...a11yProps(0)} />
                <Tab label={'Solicitud de ATS Físico'} {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={valueTab} index={0}>
              <TableInstalacionesTecnicos
                stateOT={EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO}
              />
            </CustomTabPanel>

            <CustomTabPanel value={valueTab} index={1}>
              <TableSolicitudATSFisico/>
            </CustomTabPanel>



        
      {/* </Grid> */}
    </SingleTableBoxScene>
    </>
  );
}
